import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const subscriberOffer = (id, storeId, orderId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/subscriber-offer', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
